export default __webpack_public_path__ + "static/media/hi-en.b329e008.png";